<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "QuestionsPage",
  components: {LoadingPage},
  setup(){
    
    let loading = ref(false)
    let questions = ref([])

    function get_questions() {
      loading.value = true
      FreeWorld.Heisenberg({action:'question'} , 'public_info').then((res)=>{
        loading.value = false
        questions.value = res.data
      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , get_questions)
      })
    }
    get_questions()

    function open_category(id) {
      let div = document.getElementById('box' + id);
      // let rootFontSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('font-size'));
      let heightInRem = div.scrollHeight

      div.style.height !== heightInRem + 'px' ? div.style.height = heightInRem + 'px' : div.style.height = '3.5rem'
    }


    return{
      loading,
      open_category,
      questions,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p class="text-white font-bold font-4">سوالات متداول</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div v-for="item in questions" :key="item.id" @click="open_category(item.id)" :id="'box' + item.id" class="box rounded-5 bg-custom shadow-custom p-3 overflow-hidden mb-3">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <p class="font-5 font-bold text-color">{{ item.question }}</p>

          <img class="icon-size-0-5" src="../assets/img/icon-arrowBottom.svg" alt="">
        </div>

        <p class="font-5 font-bold mb-2">{{ item.answer }}</p>
      </div>
    </div>
  </div>

</template>

<style scoped>
.box {
  height: 3.5rem;
  transition: height 0.5s ease;
}
</style>